"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const getFaviconName = theme => {
  switch (theme) {
    case 'prizm':
      return 'periscope.ico';
    case 'mds':
      return 'mckinsey.ico';
    default:
      return 'periscope.ico';
  }
};
const createFavicon = url => {
  const faviconNode = document.createElement('link');
  faviconNode.id = 'favicon';
  faviconNode.rel = 'shortcut icon';
  faviconNode.href = url;
  document.head.appendChild(faviconNode);
};
const updateFavicon = (url, favicon) => {
  favicon.href = url;
};
const Favicon = ({
  url,
  appPrefix,
  theme
}) => {
  (0, _react.useEffect)(() => {
    const favicon = document.getElementById('favicon');
    if (favicon && url) {
      updateFavicon(url, favicon);
    }
    if (favicon && !url) {
      const faviconName = getFaviconName(theme);
      updateFavicon(`${appPrefix}/${faviconName}`, favicon);
    }
    if (!favicon && url) {
      createFavicon(url);
    }
    if (!favicon && !url) {
      const faviconName = getFaviconName(theme);
      createFavicon(`${appPrefix}/${faviconName}`);
    }
  }, [url, appPrefix, theme]);
  return null;
};
var _default = exports.default = Favicon;